import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const basic: ThemedFunctor = ({ theme }) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.remSize[100]};
`;

export const hiddenPosition: ThemedFunctor = ({ theme }) => css`
  border: 1px solid ${theme.color.border.neutral.default.high};
  padding: ${theme.remSize[75]} ${theme.remSize[150]};
  border-radius: ${theme.remRounding['2XS']};
  background-color: ${theme.color.background.neutral.default.low};
  display: flex;
  align-items: center;
  gap: ${theme.remSize[100]};

  &:nth-of-type(1),
  &:nth-of-type(5) {
    margin-right: 12%;
  }

  &:nth-of-type(2),
  &:nth-of-type(4) {
    margin-right: 6%;
  }
`;

export const hiddenPositionName: ThemedFunctor = ({ theme }) => css`
  height: ${theme.remSize[100]};
  width: 5.5rem;
  display: block;
  background: red;
  border-radius: ${theme.remRounding['4XS']};
  background-color: ${theme.color.background.neutral.hover.high};
`;
